/**
 * Validate a tenant-user invitation. If the invitation includes an email
 * address then the user only needs to be logged in with that email address
 * and choose to accept the invitation. If the invitation does not include
 * an email address then it must have a hashed passcode. The user will need
 * to have the invitation ID and passcode in order to validate and accept.
 */
export const tenantUserInvitationValidateSpec = {
    uri: '/t/[tenant]/user/invitation/[invitation]/validate',
    method: 'POST',
    allowAnonymous: true,
};
